// extracted by mini-css-extract-plugin
export default {"class":"Lesson_class__qt6rL","disabled":"Lesson_disabled__ossLM","active":"Lesson_active__QUe+0","absent":"Lesson_absent__ZChK9","late":"Lesson_late__lpuE9"};